module.exports = __webpack_public_path__ + "img/t-4.ac52d70.png";